import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { scrollToTop } from "../util/helpers";
import styles from "../styles/ScrollToTopButton.module.scss";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 800) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
  }, []);

  return (
    <div className={classNames("d-none d-md-block", styles.container)} style={{ display: visible ? "inline" : "none" }}>
      <Button onClick={scrollToTop}>
        <FontAwesomeIcon icon="arrow-up" /> Top
      </Button>
    </div>
  );
};

export default ScrollToTopButton;
